// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__5N7f6","content":"LayoutSettings_content__3WTM1"};